module.exports = __webpack_public_path__ + "img/sensor-group.f1a45aae.jpg";